import { render, staticRenderFns } from "./DataNotFound.vue?vue&type=template&id=a7b9207e&scoped=true"
import script from "./DataNotFound.vue?vue&type=script&lang=ts"
export * from "./DataNotFound.vue?vue&type=script&lang=ts"
import style0 from "./DataNotFound.vue?vue&type=style&index=0&id=a7b9207e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b9207e",
  null
  
)

export default component.exports